export default __webpack_public_path__ + "static/media/winner.797306b7.gif";